import { EMPTY_VALUE } from '@src/core/config';

export const arcMphToMs = (mph?: number | string) => {
  const value = Number(mph);

  if (isNaN(value)) return EMPTY_VALUE;

  return String(value * 0.44704);
};